import React, { Suspense } from 'react'
import { Route, Switch } from 'react-router-dom'

import PageLoading from '_components/PageLoading'

const SerpChecker = React.lazy(() => import('_pages/SerpChecker' /* webpackChunkName: "serp" */))
const KeywordFinder = React.lazy(() => import('_pages/KeywordFinder' /* webpackChunkName: "kf" */))
const Overview = React.lazy(() =>
  import('_pages/Ranktracker/Overview' /* webpackChunkName: "rt-overview" */)
)
const Discovery = React.lazy(() =>
  import('_pages/Ranktracker/Discovery' /* webpackChunkName: "rt-discovery" */)
)
const Savings = React.lazy(() =>
  import('_pages/Ranktracker/Savings' /* webpackChunkName: "rt-savings" */)
)
const WebsiteAudit = React.lazy(() =>
  import('_pages/WebsiteAudit/Report' /* webpackChunkName: "wa-rep" */)
)

const randomKey = (id, min, max) => {
  return [id, Math.floor(Math.random() * (max - min + 1)) + min].join('')
}

const PreviewRoutes = () => (
  <Suspense fallback={<PageLoading />}>
    <Switch>
      <Route
        path="/preview/serp-checker"
        render={props => {
          document.title = 'SERP checker APP Preview - Ranktracker'
          return <SerpChecker {...props} key={randomKey('serp-checker', 1, 1000)} />
        }}
      />
      <Route
        path="/preview/keyword-finder"
        render={props => {
          document.title = 'Keyword Finder APP Preview - Ranktracker'
          return <KeywordFinder {...props} key={randomKey('keyword-finder', 1, 1000)} />
        }}
      />
      <Route
        path="/preview/ranktracker"
        render={props => {
          document.title = 'Keyword APP Preview - Ranktracker'
          return <Overview {...props} key={randomKey('keywords', 1, 1000)} />
        }}
      />
      <Route
        path="/preview/savings"
        render={props => {
          document.title = 'PPC Savings APP Preview - Ranktracker'
          return <Savings {...props} key={randomKey('savings', 1, 1000)} />
        }}
      />
      <Route
        path="/preview/discover"
        render={props => {
          document.title = 'Discovery Keyword APP Preview - Ranktracker'
          return <Discovery {...props} key={randomKey('discover-keywords', 1, 1000)} />
        }}
      />
      <Route
        path="/preview/web-audit"
        render={props => {
          document.title = 'Website Audit APP Preview - Ranktracker'
          return <WebsiteAudit {...props} key={randomKey('website-audit', 1, 1000)} />
        }}
      />
    </Switch>
  </Suspense>
)

export default PreviewRoutes
